import { iconCheckCircle } from "@mittwald/flow-icons/dist/checkCircle";
import { iconExclamationCircle } from "@mittwald/flow-icons/dist/exclamationCircle";
import { iconInfoCircle } from "@mittwald/flow-icons/dist/infoCircle";
import { PropsType } from "./Props";
export const statusTypeProps = {
    error: true,
    warning: true,
    info: true,
    success: true,
};
export const statusTypes = Object.keys(statusTypeProps);
export const userInteractionStatusProps = {
    destructive: true,
    warning: true,
    info: true,
    cancel: true,
    ok: true,
};
export const userInteractionStatusTypes = Object.keys(userInteractionStatusProps);
export const userInteractionStatusPropsType = new PropsType({
    warning: true,
    info: true,
    ok: true,
    cancel: true,
    destructive: true,
});
export const getStatusType = (error, warning, success) => {
    return error ? "error" : warning ? "warning" : success ? "success" : "info";
};
export const statusTypeIcons = {
    error: iconExclamationCircle,
    warning: iconExclamationCircle,
    success: iconCheckCircle,
    info: iconInfoCircle,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdHVzVHlwZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvc3RhdHVzVHlwZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsZUFBZSxFQUFFLE1BQU0sdUNBQXVDLENBQUM7QUFDeEUsT0FBTyxFQUFFLHFCQUFxQixFQUFFLE1BQU0sNkNBQTZDLENBQUM7QUFDcEYsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLHNDQUFzQyxDQUFDO0FBRXRFLE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSxTQUFTLENBQUM7QUFFcEMsTUFBTSxDQUFDLE1BQU0sZUFBZSxHQUFHO0lBQzdCLEtBQUssRUFBRSxJQUFJO0lBQ1gsT0FBTyxFQUFFLElBQUk7SUFDYixJQUFJLEVBQUUsSUFBSTtJQUNWLE9BQU8sRUFBRSxJQUFJO0NBQ0wsQ0FBQztBQUdYLE1BQU0sQ0FBQyxNQUFNLFdBQVcsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLGVBQWUsQ0FBaUIsQ0FBQztBQUV4RSxNQUFNLENBQUMsTUFBTSwwQkFBMEIsR0FBRztJQUN4QyxXQUFXLEVBQUUsSUFBSTtJQUNqQixPQUFPLEVBQUUsSUFBSTtJQUNiLElBQUksRUFBRSxJQUFJO0lBQ1YsTUFBTSxFQUFFLElBQUk7SUFDWixFQUFFLEVBQUUsSUFBSTtDQUNBLENBQUM7QUFHWCxNQUFNLENBQUMsTUFBTSwwQkFBMEIsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUNuRCwwQkFBMEIsQ0FDSSxDQUFDO0FBaUJqQyxNQUFNLENBQUMsTUFBTSw4QkFBOEIsR0FDekMsSUFBSSxTQUFTLENBQWtDO0lBQzdDLE9BQU8sRUFBRSxJQUFJO0lBQ2IsSUFBSSxFQUFFLElBQUk7SUFDVixFQUFFLEVBQUUsSUFBSTtJQUNSLE1BQU0sRUFBRSxJQUFJO0lBQ1osV0FBVyxFQUFFLElBQUk7Q0FDbEIsQ0FBQyxDQUFDO0FBRUwsTUFBTSxDQUFDLE1BQU0sYUFBYSxHQUFHLENBQzNCLEtBQWMsRUFDZCxPQUFnQixFQUNoQixPQUFnQixFQUNKLEVBQUU7SUFDZCxPQUFPLEtBQUssQ0FBQyxDQUFDLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQztBQUM5RSxDQUFDLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxlQUFlLEdBQTZDO0lBQ3ZFLEtBQUssRUFBRSxxQkFBcUI7SUFDNUIsT0FBTyxFQUFFLHFCQUFxQjtJQUM5QixPQUFPLEVBQUUsZUFBZTtJQUN4QixJQUFJLEVBQUUsY0FBYztDQUNyQixDQUFDIn0=